var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TupianClassify inner_center"},[_vm._v("\n  TupianClassify\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }